// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --field-border: 1px solid #eeeeee;
  --field-border-radius: 0.5em;
  --secondary-text: #aaaaaa;
  --sidebar-color: #f1f1f1;
  --accent-color: #2962ff;
}

* {
  box-sizing: border-box;
}

.flex {
  display: flex;
}

.flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.flex-fill {
  display: flex;
  flex: 1 1;
}

.flex-vertical {
  display: flex;
  flex-direction: column;
}

.flex-vertical-center {
  display: flex;
  align-items: center;
}

.flex-between {
  display: flex;
  justify-content: space-between;
}

.p-sm {
  padding: 0.5em;
}

.pl-sm {
  padding-left: 0.5em;
}

.pr-sm {
  padding-right: 0.5em;
}

.pb-sm {
  padding-bottom: 0.5em;
}

.p-md {
  padding: 1em;
}

.pb-md {
  padding-bottom: 1em;
}

.p-lg {
  padding: 2em;
}

.m-md {
  margin: 1em;
}

.size-md {
  font-size: 0.85em;
}

.size-lg {
  font-size: 1.5em;
}

.size-xl {
  font-size: 2em;
}

.half-width {
  width: 50%;
}

.pointer {
  cursor: pointer;
}

.uppercase {
  text-transform: uppercase;
}

.ellipsis {
  text-overflow: ellipsis;
  overflow: hidden;
}

.f-main-color {
  color: #2962ff;
}

.f-secondary-color {
  color: var(--secondary-text);
}

.b-main-color {
  background: var(--accent-color);
}

.numbers::-webkit-outer-spin-button,
.numbers::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

body {
  font-size: 14px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.bod-3 {
  border-radius: 30px;
}

.main-back {
  background: #a2cdff !important;
  display: flex;
  position: absolute;
  width: 100%;
  height: 100vh;
  top: 0px;
  left: 0px;
}

.header {
  padding-bottom: 1em;
}

.header .title {
  font-size: 1.2em;
}

.header .title span {
  font-weight: 300;
}

.card-data > div {
  padding-bottom: 1.5em;
}

.card-data > div:first-child {
  padding-top: 1.5em;
}

.card-property-title {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  margin-right: 0.5em;
}

.card-property-title strong {
  padding-bottom: 0.5em;
  font-size: 0.85em;
}

.card-property-title span {
  color: var(--secondary-text);
  font-size: 0.75em;
}

.card-property-value {
  flex: 1 1;
}

.card-number {
  background: #fafafa;
  border: var(--field-border);
  border-radius: var(--field-border-radius);
  padding: 0.5em 1em;
}

.card-number-field * {
  line-height: 1;
  margin: 0;
  padding: 0;
}

.card-number-field input {
  width: 100%;
  height: 100%;
  padding: 0.5em 1rem;
  margin: 0 0.75em;
  border: none;
  color: #888888;
  background: transparent;
  font-family: inherit;
  font-weight: 500;
}

.timer span {
  background: #311b92;
  color: #ffffff;
  width: 1.2em;
  padding: 4px 0;
  display: inline-block;
  text-align: center;
  border-radius: 3px;
}

.timer span + span {
  margin-left: 2px;
}

.timer em {
  font-style: normal;
}

.action button {
  padding: 1.1em;
  width: 100%;
  height: 100%;
  font-weight: 600;
  font-size: 1em;
  color: #ffffff;
  border: none;
  border-radius: 0.5em;
  transition: background-color 0.2s ease-in-out;
}

.action button:hover {
  background: #2979ff;
}

.input-container {
  position: relative;
  display: flex;
  align-items: center;
  height: 3em;
  overflow: hidden;
  border: var(--field-border);
  border-radius: var(--field-border-radius);
}

.input-container input,
.input-container i {
  line-height: 1;
}

.input-container input {
  flex: 1 1;
  height: 100%;
  width: 100%;
  text-align: center;
  border: none;
  border-radius: var(--field-border-radius);
  font-family: inherit;
  font-weight: 800;
  font-size: 0.85em;
}

.input-container input:focus {
  background: #e3f2fd;
  color: #283593;
}

.input-container input::placeholder {
  color: #ddd;
}

.input-container input::-webkit-outer-spin-button,
.input-container input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.input-container i {
  position: absolute;
  right: 0.5em;
}

.purchase-section {
  position: relative;
  overflow: visible;
  padding: 0 1em 1em 1em;
  background: var(--sidebar-color);
  border-top-left-radius: 0.8em;
  border-top-right-radius: 0.8em;
}

.purchase-section:before {
  content: "";
  position: absolute;
  width: 1.6em;
  height: 1.6em;
  border-radius: 50%;
  left: -0.8em;
  bottom: -0.8em;
  background: #ffffff;
}

.purchase-section:after {
  content: "";
  position: absolute;
  width: 1.6em;
  height: 1.6em;
  border-radius: 50%;
  right: -0.8em;
  bottom: -0.8em;
  background: #ffffff;
}

.card-mockup {
  position: relative;
  margin: 3em 1em 1.5em 1em;
  padding: 1.5em 1.2em;
  border-radius: 0.6em;
  background: #72a2f7;
  color: #fff;
  box-shadow: 0 0.5em 1em 0.125em rgba(0, 0, 0, 0.1);
}

.card-mockup:after {
  content: "";
  position: absolute;
  width: 25%;
  top: -0.2em;
  left: 37.5%;
  height: 0.2em;
  background: var(--accent-color);
  border-top-left-radius: 0.2em;
  border-top-right-radius: 0.2em;
}

.card-mockup:before {
  content: "";
  position: absolute;
  top: 0;
  width: 25%;
  left: 37.5%;
  height: 0.5em;
  background: rgba(41, 98, 255, 0.2117647059);
  border-bottom-left-radius: 0.2em;
  border-bottom-right-radius: 0.2em;
  box-shadow: 0 2px 15px 5px rgba(41, 98, 255, 0.3019607843);
}

.purchase-props {
  margin: 0;
  padding: 0;
  font-size: 0.8em;
  width: 100%;
}

.purchase-props li {
  width: 100%;
  line-height: 2.5;
}

.purchase-props li span {
  color: var(--secondary-text);
  font-weight: 600;
}

.separation-line {
  border-top: 1px dashed #aaa;
  margin: 0 0.8em;
}

.total-section {
  position: relative;
  overflow: hidden;
  padding: 1em;
  background: var(--sidebar-color);
  border-bottom-left-radius: 0.8em;
  border-bottom-right-radius: 0.8em;
}

.total-section:before {
  content: "";
  position: absolute;
  width: 1.6em;
  height: 1.6em;
  border-radius: 50%;
  left: -0.8em;
  top: -0.8em;
  background: #ffffff;
}

.total-section:after {
  content: "";
  position: absolute;
  width: 1.6em;
  height: 1.6em;
  border-radius: 50%;
  right: -0.8em;
  top: -0.8em;
  background: #ffffff;
}

.total-label {
  font-size: 0.8em;
  padding-bottom: 0.5em;
}

.total-section strong {
  font-size: 1.5em;
  font-weight: 800;
}

.total-section small {
  font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/features/technicalFlowScreen/technicalClearanceForm/technicalSkipPayment/TechnicalSkipPayment.scss"],"names":[],"mappings":"AAAA;EACI,iCAAA;EACA,4BAAA;EACA,yBAAA;EACA,wBAAA;EACA,uBAAA;AACJ;;AAEA;EACI,sBAAA;AACJ;;AAEA;EACI,aAAA;AACJ;;AAEA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;AACJ;;AAEA;EACI,aAAA;EACA,SAAA;AACJ;;AAEA;EACI,aAAA;EACA,sBAAA;AACJ;;AAEA;EACI,aAAA;EACA,mBAAA;AACJ;;AAEA;EACI,aAAA;EACA,8BAAA;AACJ;;AAEA;EACI,cAAA;AACJ;;AAEA;EACI,mBAAA;AACJ;;AAEA;EACI,oBAAA;AACJ;;AAEA;EACI,qBAAA;AACJ;;AAEA;EACI,YAAA;AACJ;;AAEA;EACI,mBAAA;AACJ;;AAEA;EACI,YAAA;AACJ;;AAEA;EACI,WAAA;AACJ;;AAEA;EACI,iBAAA;AACJ;;AAEA;EACI,gBAAA;AACJ;;AAEA;EACI,cAAA;AACJ;;AAEA;EACI,UAAA;AACJ;;AAEA;EACI,eAAA;AACJ;;AAEA;EACI,yBAAA;AACJ;;AAEA;EACI,uBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,cAAA;AACJ;;AAEA;EACI,4BAAA;AACJ;;AAEA;EACI,+BAAA;AACJ;;AAEA;;EAEI,wBAAA;EACA,SAAA;AACJ;;AAEA;EACI,eAAA;EACA,8JAAA;EAGA,mCAAA;EACA,kCAAA;AADJ;;AAIA;EACI,mBAAA;AADJ;;AAIA;EACI,8BAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,QAAA;EACA,SAAA;AADJ;;AAIA;EACI,mBAAA;AADJ;;AAIA;EACI,gBAAA;AADJ;;AAIA;EACI,gBAAA;AADJ;;AAIA;EACI,qBAAA;AADJ;;AAIA;EACI,kBAAA;AADJ;;AAIA;EACI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;AADJ;;AAIA;EACI,qBAAA;EACA,iBAAA;AADJ;;AAIA;EACI,4BAAA;EACA,iBAAA;AADJ;;AAIA;EACI,SAAA;AADJ;;AAIA;EACI,mBAAA;EACA,2BAAA;EACA,yCAAA;EACA,kBAAA;AADJ;;AAIA;EACI,cAAA;EACA,SAAA;EACA,UAAA;AADJ;;AAIA;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;EACA,uBAAA;EACA,oBAAA;EACA,gBAAA;AADJ;;AAIA;EACI,mBAAA;EACA,cAAA;EACA,YAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;AADJ;;AAIA;EACI,gBAAA;AADJ;;AAIA;EACI,kBAAA;AADJ;;AAIA;EACI,cAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;EACA,YAAA;EACA,oBAAA;EACA,6CAAA;AADJ;;AAIA;EACI,mBAAA;AADJ;;AAIA;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,2BAAA;EACA,yCAAA;AADJ;;AAIA;;EAEI,cAAA;AADJ;;AAIA;EACI,SAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,yCAAA;EACA,oBAAA;EACA,gBAAA;EACA,iBAAA;AADJ;;AAIA;EACI,mBAAA;EACA,cAAA;AADJ;;AAIA;EACI,WAAA;AADJ;;AAIA;;EAEI,wBAAA;EACA,SAAA;AADJ;;AAIA;EACI,kBAAA;EACA,YAAA;AADJ;;AAIA;EACI,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,gCAAA;EACA,6BAAA;EACA,8BAAA;AADJ;;AAIA;EACI,WAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;AADJ;;AAIA;EACI,WAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;AADJ;;AAIA;EACI,kBAAA;EACA,yBAAA;EACA,oBAAA;EACA,oBAAA;EACA,mBAAA;EACA,WAAA;EACA,kDAAA;AADJ;;AAIA;EACI,WAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,aAAA;EACA,+BAAA;EACA,6BAAA;EACA,8BAAA;AADJ;;AAIA;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,UAAA;EACA,WAAA;EACA,aAAA;EACA,2CAAA;EACA,gCAAA;EACA,iCAAA;EACA,0DAAA;AADJ;;AAIA;EACI,SAAA;EACA,UAAA;EACA,gBAAA;EACA,WAAA;AADJ;;AAIA;EACI,WAAA;EACA,gBAAA;AADJ;;AAIA;EACI,4BAAA;EACA,gBAAA;AADJ;;AAIA;EACI,2BAAA;EACA,eAAA;AADJ;;AAIA;EACI,kBAAA;EACA,gBAAA;EAEA,YAAA;EACA,gCAAA;EACA,gCAAA;EACA,iCAAA;AAFJ;;AAKA;EACI,WAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;AAFJ;;AAKA;EACI,WAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;EACA,WAAA;EACA,mBAAA;AAFJ;;AAKA;EACI,gBAAA;EACA,qBAAA;AAFJ;;AAKA;EACI,gBAAA;EACA,gBAAA;AAFJ;;AAKA;EACI,gBAAA;AAFJ","sourcesContent":[":root {\n    --field-border: 1px solid #eeeeee;\n    --field-border-radius: 0.5em;\n    --secondary-text: #aaaaaa;\n    --sidebar-color: #f1f1f1;\n    --accent-color: #2962ff;\n}\n\n* {\n    box-sizing: border-box;\n}\n\n.flex {\n    display: flex;\n}\n\n.flex-center {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.flex-fill {\n    display: flex;\n    flex: 1 1;\n}\n\n.flex-vertical {\n    display: flex;\n    flex-direction: column;\n}\n\n.flex-vertical-center {\n    display: flex;\n    align-items: center;\n}\n\n.flex-between {\n    display: flex;\n    justify-content: space-between;\n}\n\n.p-sm {\n    padding: 0.5em;\n}\n\n.pl-sm {\n    padding-left: 0.5em;\n}\n\n.pr-sm {\n    padding-right: 0.5em;\n}\n\n.pb-sm {\n    padding-bottom: 0.5em;\n}\n\n.p-md {\n    padding: 1em;\n}\n\n.pb-md {\n    padding-bottom: 1em;\n}\n\n.p-lg {\n    padding: 2em;\n}\n\n.m-md {\n    margin: 1em;\n}\n\n.size-md {\n    font-size: 0.85em;\n}\n\n.size-lg {\n    font-size: 1.5em;\n}\n\n.size-xl {\n    font-size: 2em;\n}\n\n.half-width {\n    width: 50%;\n}\n\n.pointer {\n    cursor: pointer;\n}\n\n.uppercase {\n    text-transform: uppercase;\n}\n\n.ellipsis {\n    text-overflow: ellipsis;\n    overflow: hidden;\n}\n\n.f-main-color {\n    color: #2962ff;\n}\n\n.f-secondary-color {\n    color: var(--secondary-text);\n}\n\n.b-main-color {\n    background: var(--accent-color);\n}\n\n.numbers::-webkit-outer-spin-button,\n.numbers::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n}\n\nbody {\n    font-size: 14px;\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\",\n        \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\",\n        sans-serif;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n.bod-3 {\n    border-radius: 30px;\n}\n\n.main-back {\n    background: #a2cdff !important;\n    display: flex;\n    position: absolute;\n    width: 100%;\n    height: 100vh;\n    top: 0px;\n    left: 0px;\n}\n\n.header {\n    padding-bottom: 1em;\n}\n\n.header .title {\n    font-size: 1.2em;\n}\n\n.header .title span {\n    font-weight: 300;\n}\n\n.card-data>div {\n    padding-bottom: 1.5em;\n}\n\n.card-data>div:first-child {\n    padding-top: 1.5em;\n}\n\n.card-property-title {\n    display: flex;\n    flex-direction: column;\n    flex: 1 1;\n    margin-right: 0.5em;\n}\n\n.card-property-title strong {\n    padding-bottom: 0.5em;\n    font-size: 0.85em;\n}\n\n.card-property-title span {\n    color: var(--secondary-text);\n    font-size: 0.75em;\n}\n\n.card-property-value {\n    flex: 1 1;\n}\n\n.card-number {\n    background: #fafafa;\n    border: var(--field-border);\n    border-radius: var(--field-border-radius);\n    padding: 0.5em 1em;\n}\n\n.card-number-field * {\n    line-height: 1;\n    margin: 0;\n    padding: 0;\n}\n\n.card-number-field input {\n    width: 100%;\n    height: 100%;\n    padding: 0.5em 1rem;\n    margin: 0 0.75em;\n    border: none;\n    color: #888888;\n    background: transparent;\n    font-family: inherit;\n    font-weight: 500;\n}\n\n.timer span {\n    background: #311b92;\n    color: #ffffff;\n    width: 1.2em;\n    padding: 4px 0;\n    display: inline-block;\n    text-align: center;\n    border-radius: 3px;\n}\n\n.timer span+span {\n    margin-left: 2px;\n}\n\n.timer em {\n    font-style: normal;\n}\n\n.action button {\n    padding: 1.1em;\n    width: 100%;\n    height: 100%;\n    font-weight: 600;\n    font-size: 1em;\n    color: #ffffff;\n    border: none;\n    border-radius: 0.5em;\n    transition: background-color 0.2s ease-in-out;\n}\n\n.action button:hover {\n    background: #2979ff;\n}\n\n.input-container {\n    position: relative;\n    display: flex;\n    align-items: center;\n    height: 3em;\n    overflow: hidden;\n    border: var(--field-border);\n    border-radius: var(--field-border-radius);\n}\n\n.input-container input,\n.input-container i {\n    line-height: 1;\n}\n\n.input-container input {\n    flex: 1 1;\n    height: 100%;\n    width: 100%;\n    text-align: center;\n    border: none;\n    border-radius: var(--field-border-radius);\n    font-family: inherit;\n    font-weight: 800;\n    font-size: 0.85em;\n}\n\n.input-container input:focus {\n    background: #e3f2fd;\n    color: #283593;\n}\n\n.input-container input::placeholder {\n    color: #ddd;\n}\n\n.input-container input::-webkit-outer-spin-button,\n.input-container input::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n}\n\n.input-container i {\n    position: absolute;\n    right: 0.5em;\n}\n\n.purchase-section {\n    position: relative;\n    overflow: visible;\n    padding: 0 1em 1em 1em;\n    background: var(--sidebar-color);\n    border-top-left-radius: 0.8em;\n    border-top-right-radius: 0.8em;\n}\n\n.purchase-section:before {\n    content: \"\";\n    position: absolute;\n    width: 1.6em;\n    height: 1.6em;\n    border-radius: 50%;\n    left: -0.8em;\n    bottom: -0.8em;\n    background: #ffffff;\n}\n\n.purchase-section:after {\n    content: \"\";\n    position: absolute;\n    width: 1.6em;\n    height: 1.6em;\n    border-radius: 50%;\n    right: -0.8em;\n    bottom: -0.8em;\n    background: #ffffff;\n}\n\n.card-mockup {\n    position: relative;\n    margin: 3em 1em 1.5em 1em;\n    padding: 1.5em 1.2em;\n    border-radius: 0.6em;\n    background: #72a2f7;\n    color: #fff;\n    box-shadow: 0 0.5em 1em 0.125em rgba(0, 0, 0, 0.1);\n}\n\n.card-mockup:after {\n    content: \"\";\n    position: absolute;\n    width: 25%;\n    top: -0.2em;\n    left: 37.5%;\n    height: 0.2em;\n    background: var(--accent-color);\n    border-top-left-radius: 0.2em;\n    border-top-right-radius: 0.2em;\n}\n\n.card-mockup:before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    width: 25%;\n    left: 37.5%;\n    height: 0.5em;\n    background: #2962ff36;\n    border-bottom-left-radius: 0.2em;\n    border-bottom-right-radius: 0.2em;\n    box-shadow: 0 2px 15px 5px #2962ff4d;\n}\n\n.purchase-props {\n    margin: 0;\n    padding: 0;\n    font-size: 0.8em;\n    width: 100%;\n}\n\n.purchase-props li {\n    width: 100%;\n    line-height: 2.5;\n}\n\n.purchase-props li span {\n    color: var(--secondary-text);\n    font-weight: 600;\n}\n\n.separation-line {\n    border-top: 1px dashed #aaa;\n    margin: 0 0.8em;\n}\n\n.total-section {\n    position: relative;\n    overflow: hidden;\n\n    padding: 1em;\n    background: var(--sidebar-color);\n    border-bottom-left-radius: 0.8em;\n    border-bottom-right-radius: 0.8em;\n}\n\n.total-section:before {\n    content: \"\";\n    position: absolute;\n    width: 1.6em;\n    height: 1.6em;\n    border-radius: 50%;\n    left: -0.8em;\n    top: -0.8em;\n    background: #ffffff;\n}\n\n.total-section:after {\n    content: \"\";\n    position: absolute;\n    width: 1.6em;\n    height: 1.6em;\n    border-radius: 50%;\n    right: -0.8em;\n    top: -0.8em;\n    background: #ffffff;\n}\n\n.total-label {\n    font-size: 0.8em;\n    padding-bottom: 0.5em;\n}\n\n.total-section strong {\n    font-size: 1.5em;\n    font-weight: 800;\n}\n\n.total-section small {\n    font-weight: 600;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
